import "./SegmentedControl.css";
import { useRef } from "preact/hooks";

export function SegmentedControl({ options, value, onChange }) {
  const optionRefs = useRef([]);

  function moveSelection(direction) {
    const currentIndex = options.findIndex((option) => option.value === value);
    const safeIndex = currentIndex >= 0 ? currentIndex : 0;
    const nextIndex = (safeIndex + direction + options.length) % options.length;
    onChange(options[nextIndex].value);
    optionRefs.current[nextIndex]?.focus();
  }

  return (
    <div class="segmented-control" role="tablist">
      {options.map((option, index) => (
        <button
          key={option.value}
          class={`segmented-control-option${option.value === value ? " active" : ""}`}
          type="button"
          role="tab"
          ref={(element) => {
            optionRefs.current[index] = element;
          }}
          onClick={() => onChange(option.value)}
          onKeyDown={(event) => {
            if (event.key === "ArrowLeft") {
              event.preventDefault();
              moveSelection(-1);
            }

            if (event.key === "ArrowRight") {
              event.preventDefault();
              moveSelection(1);
            }
          }}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
